import React, { useEffect, useCallback } from 'react';
import Icon from '@mui/material/Icon';
import PropTypes from 'prop-types';

function ToastViewers({ open = false, data = { type: 'correct', title: '', messaje: '' }, closeToast }) {
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        closeToast();
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [open, closeToast]);

  const handleClose = useCallback(() => {
    closeToast();
  }, [closeToast]);

  const icon = data.type === 'error' ? 'close' : data.type === 'info' ? 'error_outline' : 'done';
  const type = data.type === 'error' ? 'error' : data.type === 'info' ? 'info' : 'correct';

  return (
    <div className={`toastviewers ${open ? 'toastviewers_show' : 'toastviewers_hide'} ${type}`}>
      <div className="toastviewers_icon">
        <Icon>{icon}</Icon>
      </div>
      <div className="toastviewers_title">{data.title}</div>
      <div className="toastviewers_message">{data.messaje}</div>
      <div className="toastviewers_close" onClick={handleClose}>
        <Icon>close</Icon>
      </div>
    </div>
  );
}

ToastViewers.propTypes = {
  open: PropTypes.bool,
  data: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    messaje: PropTypes.string,
  }),
  closeToast: PropTypes.func.isRequired,
};

export default ToastViewers;
